import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useApiMutation } from '../../apis/useApi';
import dayjs from 'dayjs';
import ComponentHeader from '../../generic-components/ComponentHeader/ComponentHeader';
import { getDetailsValue, matchMakingPartnerDetails } from '../../utils/Config';
import ClayLayout from '@clayui/layout';

const MatchMakingPartnerDetails = () => {
    const [isBasicInfoExpand, setIsBasicInfoExpand] = useState(true);
    const [matchMakingParnterData, setMatchMakingPartnerData] = useState<any>(
        {}
    );
    const [isLoading, setIsLoading] = useState(false);
    const { matchMakingPartnerId } = useParams();
    const getCustomMatchMakingValue = (key: string) => {
        const value = matchMakingParnterData?.[key];
        if (Array.isArray(value)) {
            const names = value
                .map((item) => {
                    const name =
                        typeof item === 'object' && 'name' in item
                            ? item.name
                            : String(item);
                    return name.replace(/\s*\(.*?\)\s*/g, '').trim();
                })
                .filter(Boolean);

            return names.length > 0 ? names.join(', ') : '-';
        }
        if (
            [
                'firstSlot',
                'secondSlot',
                'thirdSlot',
                'partnerSelectedSlot'
            ]?.includes(key)
        ) {
            if (value) return dayjs(value).local().format('DD/MM/YYYY hh:mm A');
            else return '-';
        }
        if (value && typeof value === 'object' && 'name' in value) {
            return value.name?.replace(/\s*\(.*?\)\s*/g, '').trim();
        }
        return getDetailsValue(value) ?? '-';
    };

    const fetchMatchMakingPartnerData = useApiMutation<any, {}>(
        `/o/c/matchmakingpartners/${matchMakingPartnerId}`,
        'get',
        {
            onSuccess: (data) => {
                setMatchMakingPartnerData(data);
            },
            onError: (error: any) => {
                console.error('Fetch error:', error);
                setIsLoading(false);
                toast.error('Failed to fetch matchmaking data', {
                    theme: 'light',
                    autoClose: 4000
                });
            }
        }
    );
    useEffect(() => {
        setIsLoading(true);
        window.scrollTo(0, 0);
        fetchMatchMakingPartnerData.mutate({
            data: {},
            params: {
                p_auth: (window as any)?.Liferay?.authToken,
                restrictFields: 'actions'
            }
        });
    }, [matchMakingPartnerId]);
    return (
        <div className="match-making-details">
            <div className="card-body accordian-section mt-4">
                <ComponentHeader
                    title="Matchmaking Partner Details"
                    setIsRequestedInfoExpand={setIsBasicInfoExpand}
                    isRequestedInfoExpand={isBasicInfoExpand}
                    isArrowIcon={true}
                />
                <div className={isBasicInfoExpand ? 'expand' : 'collapse'}>
                    <div className="ib-hr"></div>
                    <div className="pt-0">
                        <ClayLayout.Row>
                            {/* {matchMakingPartnerDetails?.map((field) => (
                                <ClayLayout.Col
                                    key={field.key}
                                    xl={3}
                                    lg={3}
                                    md={3}
                                    sm={12}
                                    xs={12}
                                >
                                    <div>
                                        <p className="mb-1 paragraph-text">
                                            {field.label}
                                        </p>
                                        <p className="detail-content m-0">
                                            {getCustomMatchMakingValue(
                                                field?.key
                                            )}
                                        </p>
                                    </div>
                                </ClayLayout.Col>
                            ))} */}
                            {matchMakingPartnerDetails?.map((field) => {
                                const marginBottom = [
                                    'secondSlot',
                                    'thirdSlot',
                                    'partnerSelectedSlot',
                                    'partnerResponse'
                                ]?.includes(field?.key)
                                    ? 'mb-0'
                                    : 'mb-3';
                                return (
                                    <ClayLayout.Col
                                        key={field.key}
                                        xl={3}
                                        lg={3}
                                        md={3}
                                        sm={12}
                                        xs={12}
                                        className={marginBottom}
                                    >
                                        <div>
                                            <p className="mb-1 paragraph-text">
                                                {field.label}
                                            </p>
                                            <p className="detail-content m-0">
                                                {getCustomMatchMakingValue(
                                                    field?.key
                                                )}
                                            </p>
                                        </div>
                                    </ClayLayout.Col>
                                );
                            })}
                        </ClayLayout.Row>
                    </div>
                    {matchMakingParnterData?.partnerResponse?.key ==
                        'notInterested' && (
                        <div className="pt-4">
                            <div>
                                <p className="match-making-info-heading">
                                    Decline Reason
                                </p>
                                <p className="match-making-info-description">
                                    {
                                        matchMakingParnterData
                                            ?.meetingRejectionReason?.name
                                    }
                                </p>
                                <p className="match-making-info-heading mt-3">
                                    Comment
                                </p>
                                <p className="match-making-info-description">
                                    {matchMakingParnterData?.partnerComment}
                                </p>
                            </div>
                        </div>
                    )}
                    {matchMakingParnterData?.partnerResponse?.key ==
                        'interested' && (
                        <div className="pt-4">
                            <div>
                                <p className="match-making-info-heading">
                                    Approval Information
                                </p>
                                <p className="match-making-info-description">
                                    {matchMakingParnterData?.partnerComment}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MatchMakingPartnerDetails;
